import {Stack, Typography, useTheme} from '@mui/material'
import {Legend, LegendItem} from '@widgets/planning-schedule-chart'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

export const AssetCapacityCardHeader: React.FC = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {palette} = useTheme()

  return (
    <Stack direction="row" spacing={2} sx={{justifyContent: 'space-between'}}>
      <Typography variant="h3">{t('planning.assetCapacity')}</Typography>
      <Legend>
        <LegendItem
          label={t('planning.production')}
          indicator={{variant: 'circle', style: {backgroundColor: palette.primary.main}}}
        />
        <LegendItem
          label={t('planning.maintenance')}
          indicator={{variant: 'circle', style: {backgroundColor: palette.secondary.light}}}
        />
      </Legend>
    </Stack>
  )
}
